import { AArrowUp } from 'lucide-react';
import { useUIStore, FontSize } from '../../stores/uiStore';
import { Button } from './button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './dropdown-menu';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './tooltip';

const fontSizeOptions: { value: FontSize; label: string }[] = [
  { value: 'small', label: 'Klein' },
  { value: 'medium', label: 'Normal' },
  { value: 'large', label: 'Groß' },
  { value: 'xlarge', label: 'Sehr groß' },
];

export function FontSizeToggle() {
  const { fontSize, setFontSize } = useUIStore();

  return (
    <TooltipProvider>
      <Tooltip>
        <DropdownMenu>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="h-9 w-9">
                <AArrowUp className="h-6 w-6" />
                <span className="sr-only">Schriftgröße ändern</span>
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent>
            <p>Schriftgröße</p>
          </TooltipContent>
          <DropdownMenuContent align="end">
            {fontSizeOptions.map((option) => (
              <DropdownMenuItem
                key={option.value}
                onClick={() => setFontSize(option.value)}
                className={fontSize === option.value ? 'bg-accent' : ''}
              >
                <span
                  style={{
                    fontSize: option.value === 'small' ? '12px' :
                              option.value === 'medium' ? '14px' :
                              option.value === 'large' ? '16px' : '18px'
                  }}
                >
                  {option.label}
                </span>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </Tooltip>
    </TooltipProvider>
  );
}
